import { connect } from 'react-redux';

import { actualizationFetchingWithoutFlightsSelector } from 'src/routes/Checkout/store/selectors/actualization';
import { getInstantConfirm } from 'checkout/store/selectors/package';
import {
  getSimilarPackagesFetching,
  getSimilarPackagesHasAdjustParams,
  getSearcherStartDate,
  getSearcherEndDate,
  getSearcherAdultsCount,
  getSearcherKidsAges,
} from 'checkout/store/selectors/similar-packages';

import withMobile from '../../hocs/withMobile';
import { ShortInfoBlock } from '../../components/Package';

const mapStateToProps = (state) => ({
  fetching:
    actualizationFetchingWithoutFlightsSelector(state) ||
    getSimilarPackagesFetching(state),
  hasAdjustParams: getSimilarPackagesHasAdjustParams(state),
  instantConfirm: getInstantConfirm(state),
  startDate: getSearcherStartDate(state),
  endDate: getSearcherEndDate(state),
  adults: getSearcherAdultsCount(state),
  kids: getSearcherKidsAges(state),
});

export default connect(mapStateToProps)(withMobile(ShortInfoBlock));
